import React, { useState, useRef, useEffect } from 'react';

function Topbar({ openTabs, activeTabId, onTabClick, onTabClose, onReorderTabs, onCloseOthers, onCloseAll, isFullScreen, onToggleFullScreen, notifications = [], onNotificationClick, onClearNotifications }) {
    const [showNotifications, setShowNotifications] = useState(false);
    const [contextMenu, setContextMenu] = useState(null);
    const notificationRef = useRef(null);
    const tabListRef = useRef(null);
    const contextMenuRef = useRef(null);

    // Bildirim menüsü dışına tıklanınca kapat
    useEffect(() => {
        function handleClickOutside(event) {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [notificationRef]);

    // Context Menu dışına tıklanınca kapat
    useEffect(() => {
        const handleClick = (e) => {
            if (contextMenuRef.current && !contextMenuRef.current.contains(e.target)) {
                setContextMenu(null);
            }
        };
        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, [contextMenu]);

    // Sekmeleri kaydırma fonksiyonu
    const scrollTabs = (direction) => {
        if (tabListRef.current) {
            const scrollAmount = 150;
            if (direction === 'left') {
                tabListRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
            } else {
                tabListRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            }
        }
    };

    const handleDragStart = (e, index) => {
        e.dataTransfer.setData("text/plain", index);
        e.dataTransfer.effectAllowed = "move";
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
    };

    const handleDrop = (e, index) => {
        e.preventDefault();
        const dragIndex = Number(e.dataTransfer.getData("text/plain"));
        if (dragIndex !== index) {
            onReorderTabs(dragIndex, index);
        }
    };

    const handleContextMenu = (e, tabId) => {
        e.preventDefault();
        setContextMenu({
            mouseX: e.clientX,
            mouseY: e.clientY,
            tabId: tabId
        });
    };

    return (
        <div className="topbar">
            <div className="tabs-wrapper">
                <button className="scroll-btn" onClick={() => scrollTabs('left')}>‹</button>
                <div className="tab-list" ref={tabListRef}>
                    {openTabs.map((tab, index) => (
                        <div
                            key={tab.id}
                            className={`tab-item ${tab.id === activeTabId ? 'active' : ''}`}
                            onClick={() => onTabClick(tab.id)}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, index)}
                            onContextMenu={(e) => handleContextMenu(e, tab.id)}
                            title={tab.title}
                        >
                            <span className="tab-icon">{tab.icon}</span>
                            <span>{tab.title}</span>
                            {openTabs.length > 1 && (
                                <button className="tab-close-btn" onClick={(e) => { e.stopPropagation(); onTabClose(tab.id); }}>×</button>
                            )}
                        </div>
                    ))}
                </div>
                <button className="scroll-btn" onClick={() => scrollTabs('right')}>›</button>
            </div>
            <div className="topbar-actions">
                <button className="icon-btn" title={isFullScreen ? "Tam Ekrandan Çık" : "Tam Ekran"} onClick={onToggleFullScreen} style={{marginRight: '10px'}}>
                    {isFullScreen ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path></svg> : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>}
                </button>

                <div className="notification-wrapper" style={{position: 'relative'}} ref={notificationRef}>
                    <button className="icon-btn notification-btn" title="Bildirimler" onClick={() => setShowNotifications(!showNotifications)}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        <span className="badge">{notifications.length}</span>
                    </button>
                    
                    {showNotifications && (
                        <div className="notification-dropdown">
                            <div className="notification-header">
                                <span>Bildirimler ({notifications.length})</span>
                                <div style={{display: 'flex', gap: '5px'}}>
                                    {notifications.length > 0 && <button className="clear-btn" onClick={onClearNotifications} style={{color: '#e74a3b'}}>Tümünü Sil</button>}
                                    <button className="clear-btn" onClick={() => setShowNotifications(false)}>Kapat</button>
                                </div>
                            </div>
                            <div className="notification-list">
                                {notifications.length > 0 ? (
                                    notifications.map(notif => (
                                        <div key={notif.id} className="notification-item" onClick={() => { onNotificationClick(notif); setShowNotifications(false); }}>
                                            <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
                                                <span style={{fontSize: '1.2rem', marginTop: '-2px'}}>
                                                    {notif.type === 'appointment' ? '📅' : (notif.type === 'inventory' ? '⚠️' : '🔔')}
                                                </span>
                                                <div>
                                                    <p style={{margin: '0 0 5px 0', fontWeight: notif.type === 'inventory' ? 'bold' : 'normal', color: notif.type === 'inventory' ? '#e74a3b' : 'inherit'}}>{notif.text}</p>
                                                    <small>{notif.time}</small>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="notification-item" style={{textAlign: 'center', color: '#858796', cursor: 'default'}}>
                                        <p style={{margin:0}}>Yeni bildirim yok.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {contextMenu && (
                <div 
                    className="context-menu" 
                    style={{ top: contextMenu.mouseY, left: contextMenu.mouseX }}
                    ref={contextMenuRef}
                >
                    <button className="context-menu-item" onClick={() => { onCloseOthers(contextMenu.tabId); setContextMenu(null); }}>Diğerlerini Kapat</button>
                    <button className="context-menu-item" onClick={() => { onCloseAll(); setContextMenu(null); }}>Tümünü Kapat</button>
                </div>
            )}
        </div>
    );
}

export default Topbar;